export const DEFAULT_LOCALE = 'de'
export const LOCALE = 'de'
